import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cache-rules-editor',
  template: `<p>
  cache-rules-editor works!
</p>
`,
  styles: [``]
})
export class CacheRulesEditorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
